class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      this.freeShippingCounter();
    }, { once: true });

    this.dispatchEvent(new Event('cartDrawer.open'));

    document.body.classList.add('overflow-hidden');
    this.countdown();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  countdown() {
    if (!this.dataset.countdown) return
    const timer = this.querySelector('.cart-countdown')
    if (timer) return
    const footer = this.querySelector('.cart-drawer__footer')
    if (!footer) return

    const text = this.dataset.countdown
    if (text.indexOf('[[') === -1 || text.indexOf(']]') === -1) return
    const textWithTimer = text.replace('[[', '<span class="countdown-timer">').replace(']]', '</span>')    
    footer.insertAdjacentHTML('afterbegin', `<span class="cart-countdown">${textWithTimer}</span>`)

    const startTimer = () => {
      var presentTime = this.querySelector('.countdown-timer').innerHTML;
      var timeArray = presentTime.split(/[:]+/);
      var m = parseInt(timeArray[0]);
      var s = checkSecond((parseInt(timeArray[1]) - 1));
      if(s==59){m=m-1}
      if(m<0){
        return
      }

      document.querySelector('.countdown-timer').innerHTML = m + ":" + s;
      setTimeout(startTimer, 1000);
    }

    const checkSecond = (sec) => {
      if (sec < 10 && sec >= 0) {sec = "0" + sec}; // add zero in front of numbers < 10
      if (sec < 0) {sec = "59"};
      return sec;
    }

    startTimer();
  }

  freeShippingCounter() {    
    const freeShippingEl = this.querySelector('.free-shipping-counter')
    if (!freeShippingEl) return
    const progress = this.querySelector('.free-shipping-counter__bar--progress')
    const total = this.querySelector('.free-shipping-counter__bar--total')
    const remainingAmountEl = document.querySelector('.free-shipping-counter__remaining')
    const subheading = this.querySelector('.free-shipping-counter__subheading')
    const freeShippingThreshold = parseFloat(freeShippingEl.dataset.threshold)
    const cartTotal = parseFloat(this.querySelector('.totals__subtotal-value').innerText.replace('$', ''))
    const remaining = freeShippingThreshold - cartTotal
    const progressPercent = Math.min(100, ((cartTotal * 100) / freeShippingThreshold))
    total.innerHTML = `$${cartTotal.toFixed(2)}`
    remainingAmountEl.innerHTML = `$${remaining.toFixed(2)}`
    progress.style.width = `${progressPercent}%`
    if (cartTotal >= freeShippingThreshold) {
      total.style.opacity = 0
      subheading.style.display = 'none'
    } else {
      total.style.opacity = 1
      subheading.style.display = 'block'
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
